import VimeoPlayer from '@vimeo/player'

interface LoadContainerOpts {
	isModal?: boolean
}

export default async (
	el: HTMLElement,
	$el: JQuery<HTMLElement>,
	opt: LoadContainerOpts,
) => {

	let videoEl = el.getElementsByTagName('video')[0]
	const isVideo = videoEl ? true : false
	const isVimeo = !isVideo && el.querySelector('iframe')?.src.includes('vimeo') ? true : false
	const isYoutube = !isVideo && el.querySelector('iframe')?.src.includes('youtube') ? true : false
	let ytPlayer: any

	const loadYoutubeVideo = () => {
		ytPlayer = new YT.Player(el.getElementsByTagName('iframe')[0]?.id, {
			events: {
				onReady: onPlayerReady
			},
		})
	}

	const onPlayerReady = (event: YT.PlayerEvent) => {
		ytPlayer = event.target as YT.Player
	}

	if(isYoutube) {
		if (!window.YT) {
			// This is currently added via the CSHTML file.
			// We can add it here dynamically if needed.
			console.log('YouTube IFrame API Library not loaded')
		} else {
			loadYoutubeVideo()
		}
	}

	if(isVimeo) {
		videoEl = new VimeoPlayer(el?.querySelector('iframe')?.id)
	}

    if(opt.isModal) {

        $el.find('.c-videoplayer__open').on('click', function () {
			$el.addClass('is-active')
            document.getElementsByTagName('body')[0].classList.add('overflow-hidden')
		})

        $el.find('.c-videoplayer__play').on('click', function () {

            $(this).hide()

			if(ytPlayer) {
				ytPlayer.playVideo()
			} else {
				videoEl.play()
			}

            document.getElementsByTagName('body')[0].classList.add('overflow-hidden')
		})

        $el.find('.c-videoplayer__modal__close').on('click', function () {

			if (ytPlayer) {
				ytPlayer.pauseVideo()
			} else {
				videoEl.pause()
			}

			$el.removeClass('is-active')
			$el.find('.c-videoplayer__play').show()
            document.getElementsByTagName('body')[0].classList.remove('overflow-hidden')
		})

        videoEl?.addEventListener('pause', (event) => {
			if (videoEl.paused == true) {
				$el.find('.c-videoplayer__play').show()
			}
		})

    } else {

		$el.find('.c-videoplayer__play').on('click', function () {
			$(this).hide()
			videoEl.setAttribute('controls', 'controls')
			if (ytPlayer) {
				ytPlayer.playVideo()
			} else {
				videoEl.play()
			}
		})

		videoEl?.addEventListener('pause', (event) => {
			if (videoEl.paused == true) {
				$el.find('.c-videoplayer__play').show()
			}
		})

    }

}
